import { useState } from 'react'
import { useDMConversations } from '../../hooks/useDMConversations'
import { useAdvisorPresence } from '../../hooks/useAdvisorPresence'
import { InboxNotificationTab } from '../../components/Inbox/InboxNotificationTab'
import { DMConversationList } from '../../components/Inbox/DMConversationList'
import { DMThread } from '../../components/Inbox/DMThread'

const TABS = [
  { id: 'mention',            label: '@Mentions' },
  { id: 'task_reassigned',    label: 'Assigned to Me' },
  { id: 'task_watcher_added', label: 'Watching' },
  { id: 'messages',           label: 'Messages' },
]

export function InboxPage({ isDarkMode, onNavigate }) {
  const [activeTab, setActiveTab] = useState('mention')
  const [selectedConvId, setSelectedConvId] = useState(null)
  const { conversations, loading: convLoading, getOrCreateConversation } = useDMConversations()
  const { getStatus, getLastSeen, setStandby, myStatus } = useAdvisorPresence()

  const selectedConv = conversations.find(c => c.id === selectedConvId)
  const otherAdvisor = selectedConv?.otherAdvisor ?? null

  return (
    <div className={`flex flex-col h-full ${isDarkMode ? 'bg-slate-900' : 'bg-sfp-lightgray'}`}>
      {/* Page header with tabs */}
      <div className={`flex items-center gap-1 px-4 pt-4 pb-0 border-b flex-shrink-0 ${isDarkMode ? 'border-slate-700' : 'border-gray-200'}`}>
        <h1 className={`text-lg font-bold mr-4 ${isDarkMode ? 'text-white' : 'text-sfp-darkgray'}`}>Inbox</h1>
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 text-sm font-medium border-b-2 transition -mb-px ${
              activeTab === tab.id
                ? 'border-sfp-orange text-sfp-orange'
                : isDarkMode
                  ? 'border-transparent text-slate-400 hover:text-slate-200'
                  : 'border-transparent text-gray-500 hover:text-sfp-darkgray'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Body */}
      <div className="flex-1 overflow-hidden">
        {activeTab !== 'messages' ? (
          <InboxNotificationTab
            key={activeTab}
            type={activeTab}
            isDarkMode={isDarkMode}
            onNavigate={onNavigate}
          />
        ) : (
          <div className="flex h-full">
            <DMConversationList
              conversations={conversations}
              loading={convLoading}
              selectedId={selectedConvId}
              onSelect={setSelectedConvId}
              getOrCreateConversation={getOrCreateConversation}
              getStatus={getStatus}
              myStatus={myStatus}
              setStandby={setStandby}
              isDarkMode={isDarkMode}
            />
            <div className="flex-1 overflow-hidden">
              {selectedConv ? (
                <DMThread
                  key={selectedConvId}
                  conversationId={selectedConvId}
                  otherAdvisor={otherAdvisor}
                  getStatus={getStatus}
                  getLastSeen={getLastSeen}
                  isDarkMode={isDarkMode}
                />
              ) : (
                <div className={`flex items-center justify-center h-full text-sm ${isDarkMode ? 'text-slate-500' : 'text-gray-400'}`}>
                  Select a conversation or start a new one
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
